import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import EmailInput from '../components/EmailInput';
import bankBranchData from '../utils/bank_branch.json';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v1';

const kenyanCountiesData = [
  { name: "Mombasa", code: 1, capital: "Mombasa City", subCounties: ["Changamwe", "Jomvu", "Kisauni", "Likoni", "Mvita", "Nyali"] },
  { name: "Kwale", code: 2, capital: "Kwale Town", subCounties: ["Kinango", "Matuga", "Msambweni"] },
  { name: "Kilifi", code: 3, capital: "Kilifi Town", subCounties: ["Ganze", "Kaloleni", "Kilifi", "Magarini", "Malindi"] },
  { name: "Tana River", code: 4, capital: "Hola", subCounties: ["Bura", "Galole", "Garsen"] },
  { name: "Lamu", code: 5, capital: "Lamu Town", subCounties: ["Amu", "Faza", "Hindi"] },
  { name: "Taita Taveta", code: 6, capital: "Mwatate", subCounties: ["Mwatate", "Taveta", "Voi"] },
  { name: "Garissa", code: 7, capital: "Garissa", subCounties: ["Balambala", "Dadaab", "Fafi", "Garissa", "Ijara", "Lagdera"] },
  { name: "Wajir", code: 8, capital: "Wajir", subCounties: ["Buna", "Eldas", "Tarbaj", "Wajir Bor", "Wajir East", "Wajir North", "Wajir South", "Wajir West"] },
  { name: "Mandera", code: 9, capital: "Mandera", subCounties: ["Banissa", "Kutulo", "Mandera East", "Mandera North", "Mandera South", "Mandera West"] },
  { name: "Marsabit", code: 10, capital: "Marsabit", subCounties: ["Laisamis", "Loiyangalani", "Marsabit Central", "Marsabit North", "Marsabit South", "North Horr"] },
  { name: "Isiolo", code: 11, capital: "Isiolo", subCounties: ["Isiolo Central", "Isiolo North", "Isiolo South", "Merti"] },
  { name: "Meru", code: 12, capital: "Meru", subCounties: ["Buuri", "Igembe Central", "Igembe North", "Igembe South", "Imenti Central", "Imenti North", "Imenti South", "Meru Central", "Meru North", "Meru South", "Tigania East", "Tigania West"] },
  { name: "Tharaka Nithi", code: 13, capital: "Kathwana", subCounties: ["Chuka", "Igambang'ombe", "Maara", "Tharaka"] },
  { name: "Embu", code: 14, capital: "Embu", subCounties: ["Embu East", "Embu North", "Embu West", "Mbeere North", "Mbeere South"] },
  { name: "Kitui", code: 15, capital: "Kitui", subCounties: ["Chuluni", "Ikutha", "Kisasi", "Kitui Central", "Kitui East", "Kitui Rural", "Kitui South", "Kyuso", "Lower Yatta", "Masinga", "Matinyani", "Migwani", "Mutomo", "Mwingi Central", "Mwingi East", "Mwingi North", "Mwingi West", "Nzambani", "Tseikuru"] },
  { name: "Machakos", code: 16, capital: "Machakos", subCounties: ["Athi River", "Kangundo", "Kathiani", "Machakos", "Masinga", "Matungulu", "Mwala", "Yatta"] },
  { name: "Makueni", code: 17, capital: "Wote", subCounties: ["Kaiti", "Kibwezi", "Kilungu", "Makindu", "Makueni", "Mbooni", "Masinga", "Mtito Andei", "Nzaui"] },
  { name: "Kajiado", code: 18, capital: "Kajiado", subCounties: ["Kajiado Central", "Kajiado East", "Kajiado North", "Kajiado South", "Kajiado West"] },
  { name: "Kiambu", code: 19, capital: "Kiambu", subCounties: ["Gatanga", "Gatundu North", "Gatundu South", "Githunguri", "Gikambura", "Juja", "Kabete", "Kikuyu", "Limuru", "Lari", "Ruiru", "Thika Town"] },
  { name: "Turkana", code: 20, capital: "Lodwar", subCounties: ["Kakuma", "Katilu", "Kibish", "Lodwar", "Loima", "Turkana Central", "Turkana East", "Turkana North", "Turkana South", "Turkana West"] },
  { name: "West Pokot", code: 21, capital: "Kapenguria", subCounties: ["Kacheliba", "Pokot Central", "Pokot North", "Pokot South"] },
  { name: "Samburu", code: 22, capital: "Maralal", subCounties: ["Baragoi", "Kirisia", "Samburu Central", "Samburu East", "Samburu North"] },
  { name: "Trans Nzoia", code: 23, capital: "Kitale", subCounties: ["Cherangany", "Endebess", "Kwanza", "Saboti", "Trans Nzoia East", "Trans Nzoia West"] },
  { name: "Uasin Gishu", code: 24, capital: "Eldoret", subCounties: ["Ainabkoi", "Kapseret", "Kesses", "Moiben", "Soy", "Turbo"] },
  { name: "Elgeyo Marakwet", code: 25, capital: "Iten", subCounties: ["Keiyo North", "Keiyo South", "Marakwet East", "Marakwet West"] },
  { name: "Nandi", code: 26, capital: "Kapsabet", subCounties: ["Aldai", "Chesumei", "Emgwen", "Kilibwoni", "Mosop", "Nandi Hills", "Tinderet"] },
  { name: "Baringo", code: 27, capital: "Kabarnet", subCounties: ["Baringo Central", "Baringo North", "Baringo South", "Baringo South", "Eldama Ravine", "Mogotio", "Tiaty"] },
  { name: "Laikipia", code: 28, capital: "Nanyuki", subCounties: ["Laikipia East", "Laikipia North", "Laikipia West"] },
  { name: "Nakuru", code: 29, capital: "Nakuru", subCounties: ["Bahati", "Gilgil", "Kuresoi North", "Kuresoi South", "Molo", "Naivasha", "Nakuru Town East", "Nakuru Town West", "Njoro", "Rongai", "Subukia"] },
  { name: "Narok", code: 30, capital: "Narok", subCounties: ["Narok East", "Narok North", "Narok South", "Narok West"] },
  { name: "Kajiado", code: 31, capital: "Kajiado", subCounties: ["Kajiado Central", "Kajiado East", "Kajiado North", "Kajiado South", "Kajiado West"] },
  { name: "Kericho", code: 32, capital: "Kericho", subCounties: ["Ainamoi", "Belgut", "Bureti", "Kipkelion East", "Kipkelion West", "Soin Sigowet"] },
  { name: "Bomet", code: 33, capital: "Bomet", subCounties: ["Bomet Central", "Bomet East", "Chepalungu", "Konoin", "Sotik"] },
  { name: "Kakamega", code: 34, capital: "Kakamega", subCounties: ["Butere", "Kakamega Central", "Kakamega East", "Kakamega North", "Kakamega South", "Khwisero", "Lugari", "Lukuyani", "Malava", "Matungu", "Mumias East", "Mumias West", "Navakholo"] },
  { name: "Vihiga", code: 35, capital: "Vihiga", subCounties: ["Emuhaya", "Hamisi", "Luanda", "Sabatia", "Vihiga"] },
  { name: "Bungoma", code: 36, capital: "Bungoma", subCounties: ["Bumula", "Kabuchai", "Kanduyi", "Kimilili", "Mt. Elgon", "Sirisia", "Tongaren", "Webuye East", "Webuye West"] },
  { name: "Busia", code: 37, capital: "Busia", subCounties: ["Bunyala", "Busia", "Butula", "Nambale", "Samia", "Teso North", "Teso South"] },
  { name: "Siaya", code: 38, capital: "Siaya", subCounties: ["Alego Usonga", "Bondo", "Gem", "Rarieda", "Ugenya", "Ugunja"] },
  { name: "Kisumu", code: 39, capital: "Kisumu", subCounties: ["Kisumu Central", "Kisumu East", "Kisumu West", "Mohoroni", "Nyakach", "Nyando", "Seme"] },
  { name: "Homa Bay", code: 40, capital: "Homa Bay", subCounties: ["Homa Bay Town", "Kabondo Kasipul", "Karachuonyo", "Mbita", "Ndhiwa", "Rangwe", "Suba"] },
  { name: "Migori", code: 41, capital: "Migori", subCounties: ["Awendo", "Kuria East", "Kuria West", "Migori", "Nyatike", "Rongo", "Suna East", "Suna West", "Uriri"] },
  { name: "Kisii", code: 42, capital: "Kisii", subCounties: ["Bobasi", "Bomachoge Borabu", "Bomachoge Chache", "Kitutu Chache North", "Kitutu Chache South", "Nyaribari Chache", "Nyaribari Masaba", "South Mugirango"] },
  { name: "Nyamira", code: 43, capital: "Nyamira", subCounties: ["Borabu", "Manga", "Masaba North", "Nyamira North", "Nyamira South"] },
  { name: "Nairobi", code: 44, capital: "Nairobi City", subCounties: ["Dagoretti North", "Dagoretti South", "Embakasi Central", "Embakasi East", "Embakasi North", "Embakasi South", "Embakasi West", "Kamukunji", "Kasarani", "Kibra", "Lang'ata", "Makadara", "Mathare", "Roysambu", "Ruaraka", "Starehe", "Westlands"] }
];

function RecruiterApplication() {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    mobile_number: '',
    nationality: '',
    id_passport: '',
    kra_pin: '',
    county: '',
    subcounty: '',
    location: '',
    sublocation: '',
    village: '',
    residential_address: '',
    postal_address: '',
    bank_account: '',
    bank_name: '',
    branch_code: '',
    cover_letter: ''
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const selectedBank = bankBranchData.find(b => b.bank_name === formData.bank_name);
  const availableBranches = selectedBank ? selectedBank.branches : [];

  const selectedCounty = kenyanCountiesData.find(c => c.name === formData.county);
  const availableSubcounties = selectedCounty ? selectedCounty.subCounties : [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'county') {
      setFormData(prev => ({ ...prev, county: value, subcounty: '' }));
    }
    if (name === 'bank_name') {
      setFormData(prev => ({ ...prev, bank_name: value, branch_code: '' }));
    }
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleEmailChange = (value) => {
    setFormData(prev => ({ ...prev, email: value }));
    if (errors.email) {
      setErrors(prev => ({ ...prev, email: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.full_name.trim()) {
      newErrors.full_name = 'Full name is required';
    } else if (formData.full_name.length < 2) {
      newErrors.full_name = 'Full name must be at least 2 characters';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = 'Mobile number is required';
    } else if (formData.mobile_number.length < 10) {
      newErrors.mobile_number = 'Mobile number must be at least 10 characters';
    }

    if (!formData.nationality.trim()) {
      newErrors.nationality = 'Nationality is required';
    }

    if (!formData.id_passport.trim()) {
      newErrors.id_passport = 'ID/Passport number is required';
    }

    if (!formData.county) {
      newErrors.county = 'County is required';
    }

    if (!formData.residential_address.trim()) {
      newErrors.residential_address = 'Residential address is required';
    }

    if (!formData.bank_account.trim()) {
      newErrors.bank_account = 'Bank account is required for payment processing';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error('Please fix the errors in the form');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/hr/applications`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to submit application');
      }

      toast.success('Application submitted successfully! We will review your application and get back to you.');
      setFormData({
        full_name: '',
        email: '',
        mobile_number: '',
        nationality: '',
        id_passport: '',
        kra_pin: '',
        county: '',
        subcounty: '',
        location: '',
        sublocation: '',
        village: '',
        residential_address: '',
        postal_address: '',
        bank_account: '',
        bank_name: '',
        branch_code: '',
        cover_letter: ''
      });
    } catch (error) {
      toast.error(error.message || 'Failed to submit application. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-info">
          <div className="public-info-logo">
            <img src="/assets/logo.png" alt="OUK Logo" />
          </div>
          <h1>Become a Student Recruiter</h1>
          <p className="subtitle">Join our team and help students discover their educational opportunities at OUK while earning commissions on every successful recruitment.</p>

          <div className="info-benefits">
            <div className="benefit-item">
              <div className="benefit-icon">💰</div>
              <div className="benefit-text">
                <h3>Earn Competitive Commissions</h3>
                <p>Get paid KES 500 for every student you admit and KES 300 for every enrolled student. Unlimited earning potential with no caps.</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🎓</div>
              <div className="benefit-text">
                <h3>Help Students Achieve Their Dreams</h3>
                <p>Guide prospective students through the admission process and connect them with quality higher education opportunities at OUK.</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">📱</div>
              <div className="benefit-text">
                <h3>Track Everything in Real-Time</h3>
                <p>Use your personalized dashboard to track admissions, enrollments, and earnings. Get instant notifications on your progress.</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🏆</div>
              <div className="benefit-text">
                <h3>Recognition & Rewards</h3>
                <p>Top-performing recruiters get featured on our leaderboard and receive special rewards. Your hard work doesn't go unnoticed.</p>
              </div>
            </div>
          </div>

          <div className="public-info-footer">
            <p>© 2024 OUK — Open University of Kenya. All rights reserved.</p>
          </div>
        </div>

        <div className="public-form-side">
          <div className="form-header">
            <h2>Apply Now</h2>
            <p>Fill in your details to get started as a student recruiter</p>
          </div>
          <div className="application-form-container">
          <form onSubmit={handleSubmit} className="application-form">
            <div className="form-section">
              <h2>Personal Information</h2>

              <div className="form-row">
                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Full Name *</label>
                  <input
                    type="text"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleChange}
                    className={`form-input ${errors.full_name ? 'error' : ''}`}
                    placeholder="Enter your full name"
                  />
                  {errors.full_name && <span className="error-message">{errors.full_name}</span>}
                </div>

                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Email Address *</label>
                  <EmailInput
                    value={formData.email}
                    onChange={handleEmailChange}
                    placeholder="Enter your email"
                    showValidation={false}
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Mobile Number *</label>
                  <input
                    type="text"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleChange}
                    className={`form-input ${errors.mobile_number ? 'error' : ''}`}
                    placeholder="e.g., +254712345678"
                  />
                  {errors.mobile_number && <span className="error-message">{errors.mobile_number}</span>}
                </div>

                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Nationality *</label>
                  <select
                    name="nationality"
                    value={formData.nationality}
                    onChange={handleChange}
                    className={`form-select ${errors.nationality ? 'error' : ''}`}
                  >
                    <option value="">Select Nationality</option>
                    {[
                      'Afghan', 'Albanian', 'Algerian', 'American', 'Andorran', 'Angolan', 'Argentine', 'Armenian', 'Australian', 'Austrian', 'Azerbaijani',
                      'Bahamian', 'Bahraini', 'Bangladeshi', 'Barbadian', 'Belarusian', 'Belgian', 'Belizean', 'Beninese', 'Bhutanese', 'Bolivian', 'Bosnian', 'Botswanan', 'Brazilian', 'British', 'Bruneian', 'Bulgarian', 'Burkinabe', 'Burundian',
                      'Cambodian', 'Cameroonian', 'Canadian', 'Cape Verdean', 'Central African', 'Chadian', 'Chilean', 'Chinese', 'Colombian', 'Comoran', 'Congolese', 'Costa Rican', 'Croatian', 'Cuban', 'Cypriot', 'Czech',
                      'Danish', 'Djiboutian', 'Dominican', 'Dutch',
                      'Ecuadorian', 'Egyptian', 'Emirati', 'Equatorial Guinean', 'Eritrean', 'Estonian', 'Ethiopian',
                      'Fijian', 'Filipino', 'Finnish', 'French',
                      'Gabonese', 'Gambian', 'Georgian', 'German', 'Ghanaian', 'Greek', 'Grenadian', 'Guatemalan', 'Guinean', 'Guyanese',
                      'Haitian', 'Honduran', 'Hungarian',
                      'Icelandic', 'Indian', 'Indonesian', 'Iranian', 'Iraqi', 'Irish', 'Israeli', 'Italian', 'Ivorian',
                      'Jamaican', 'Japanese', 'Jordanian',
                      'Kazakhstani', 'Kenyan', 'Kittitian', 'Kuwaiti', 'Kyrgyzstani',
                      'Laotian', 'Latvian', 'Lebanese', 'Liberian', 'Libyan', 'Liechtensteiner', 'Lithuanian', 'Luxembourger',
                      'Macedonian', 'Malagasy', 'Malawian', 'Malaysian', 'Maldivian', 'Malian', 'Maltese', 'Marshallese', 'Mauritanian', 'Mauritian', 'Mexican', 'Moldovan', 'Monacan', 'Mongolian', 'Montenegrin', 'Moroccan', 'Mozambican', 'Myanma',
                      'Namibian', 'Nepalese', 'New Zealander', 'Nicaraguan', 'Nigerien', 'Nigerian', 'North Korean', 'Norwegian',
                      'Omani',
                      'Pakistani', 'Palauan', 'Palestinian', 'Panamanian', 'Papua New Guinean', 'Paraguayan', 'Peruvian', 'Polish', 'Portuguese',
                      'Qatari',
                      'Romanian', 'Russian', 'Rwandan',
                      'Saint Lucian', 'Salvadoran', 'Samoan', 'San Marinese', 'Sao Tomean', 'Saudi Arabian', 'Senegalese', 'Serbian', 'Seychellois', 'Sierra Leonean', 'Singaporean', 'Slovak', 'Slovenian', 'Solomon Islander', 'Somali', 'South African', 'South Korean', 'South Sudanese', 'Spanish', 'Sri Lankan', 'Sudanese', 'Surinamese', 'Swazi', 'Swedish', 'Swiss', 'Syrian',
                      'Taiwanese', 'Tajik', 'Tanzanian', 'Thai', 'Togolese', 'Tongan', 'Trinidadian', 'Tunisian', 'Turkish', 'Turkmen', 'Tuvaluan',
                      'Ugandan', 'Ukrainian', 'Uruguayan', 'Uzbek',
                      'Vanuatuan', 'Vatican', 'Venezuelan', 'Vietnamese',
                      'Yemeni',
                      'Zambian', 'Zimbabwean'
                    ].sort().map(country => (
                      <option key={country} value={country}>{country}</option>
                    ))}
                  </select>
                  {errors.nationality && <span className="error-message">{errors.nationality}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>ID/Passport Number *</label>
                  <input
                    type="text"
                    name="id_passport"
                    value={formData.id_passport}
                    onChange={handleChange}
                    className={`form-input ${errors.id_passport ? 'error' : ''}`}
                    placeholder="Enter your ID or Passport number"
                  />
                  {errors.id_passport && <span className="error-message">{errors.id_passport}</span>}
                </div>

                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>KRA PIN</label>
                  <input
                    type="text"
                    name="kra_pin"
                    value={formData.kra_pin}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Enter your KRA PIN (optional)"
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h2>Location Information</h2>

              <div className="form-row">
                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>County *</label>
                  <select
                    name="county"
                    value={formData.county}
                    onChange={handleChange}
                    className={`form-select ${errors.county ? 'error' : ''}`}
                  >
                    <option value="">Select County</option>
                    {kenyanCountiesData.map(county => (
                      <option key={county.code} value={county.name}>{county.name}</option>
                    ))}
                  </select>
                  {errors.county && <span className="error-message">{errors.county}</span>}
                </div>

                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Subcounty</label>
                  <select
                    name="subcounty"
                    value={formData.subcounty}
                    onChange={handleChange}
                    className="form-select"
                    disabled={!formData.county}
                  >
                    <option value="">Select Subcounty</option>
                    {availableSubcounties.map(sub => (
                      <option key={sub} value={sub}>{sub}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Location</label>
                  <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Enter location (optional)"
                  />
                </div>

                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Sublocation</label>
                  <input
                    type="text"
                    name="sublocation"
                    value={formData.sublocation}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Enter sublocation (optional)"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Village</label>
                  <input
                    type="text"
                    name="village"
                    value={formData.village}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Enter village (optional)"
                  />
                </div>

                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Postal Address</label>
                  <input
                    type="text"
                    name="postal_address"
                    value={formData.postal_address}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Enter postal address (optional)"
                  />
                </div>
              </div>

              <div className="form-group">
                <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Residential Address *</label>
                <textarea
                  name="residential_address"
                  value={formData.residential_address}
                  onChange={handleChange}
                  className={`form-input ${errors.residential_address ? 'error' : ''}`}
                  rows="3"
                  placeholder="Enter your residential address"
                />
                {errors.residential_address && <span className="error-message">{errors.residential_address}</span>}
              </div>
            </div>

            <div className="form-section">
              <h2>Payment Information</h2>
              <p className="form-hint">Required for commission payments</p>

              <div className="form-row">
                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Bank Account Number *</label>
                  <input
                    type="text"
                    name="bank_account"
                    value={formData.bank_account}
                    onChange={handleChange}
                    className={`form-input ${errors.bank_account ? 'error' : ''}`}
                    placeholder="Enter your bank account number"
                  />
                  {errors.bank_account && <span className="error-message">{errors.bank_account}</span>}
                </div>

                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Bank Name</label>
                  <select
                    name="bank_name"
                    value={formData.bank_name}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select Bank</option>
                    {bankBranchData.map(bank => (
                      <option key={bank.bank_name} value={bank.bank_name}>{bank.bank_name}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Branch Code</label>
                  <select
                    name="branch_code"
                    value={formData.branch_code}
                    onChange={handleChange}
                    className="form-select"
                    disabled={!formData.bank_name}
                  >
                    <option value="">Select Branch</option>
                    {availableBranches.map(branch => (
                      <option key={branch.branch_code} value={branch.branch_code}>
                        {branch.branch_code} - {branch.branch_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-section">
              <h2>Additional Information</h2>

              <div className="form-group">
                <label style={{ fontWeight: 600, color: '#64748b', fontSize: '13px' }}>Cover Letter</label>
                <textarea
                  name="cover_letter"
                  value={formData.cover_letter}
                  onChange={handleChange}
                  className="form-input"
                  rows="5"
                  placeholder="Tell us why you want to become a student recruiter and why you would be good at it..."
                />
              </div>
            </div>

            <div className="form-actions">
              <button
                type="submit"
                className="btn btn-primary btn-lg"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit Application'}
              </button>
            </div>

            <div className="form-footer">
              <p>
                Already have an account? <Link to="/login">Login here</Link>
              </p>
            </div>
          </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecruiterApplication;
